import React from "react";
import DefaultSVGLogo, { OptionalDefaultLogoProps } from "./DefaultSVGLogo";

export const NutritionColor = ({ alt, ...logoProps }: OptionalDefaultLogoProps) => (
  <DefaultSVGLogo
    src="/img/nutrition_color.svg"
    alt={alt ?? "Nutrition color"}
    {...logoProps} />
);
